import React, { useEffect, useState } from 'react';
import { LoadingModal } from 'components/response/LoadingModal';
import { FormContext } from 'context/FormContext';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import { useLogin } from 'hooks/useLogin';
import { useHistory } from 'react-router-dom';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import { MultiFormContainer } from 'components/multi-form/MultiFormContainer';
import { useCreditLiquidationFormContainerControl } from '../hooks/useCreditLiquidationFormContainerControl';
import { CREDIT_LIQUIDATION_ACTIONS } from '../constants/CreditLiquidationActions';
import {
	CreditLiquidationPersonalInfoForm
} from '../components/single-form-view/credit/liquidation/CreditLiquidationPersonalInfoForm';
import {
	CreditLiquidationEntityInfoForm
} from '../components/single-form-view/credit/liquidation/CreditLiquidationEntityInfoForm';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from '../constants/ResponseType';

const config = [
	{
		buttonBackName: 'Home',
		buttonNextName: 'Comenzar',
		backAction: CREDIT_LIQUIDATION_ACTIONS.BACK_TO_HOME,
		nextAction: CREDIT_LIQUIDATION_ACTIONS.SAVE_FORM_IN_STORAGE,
	},
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Guardar',
		backAction: CREDIT_LIQUIDATION_ACTIONS.RESET_ID_STATUS_AND_BACK_STEP,
		nextAction: CREDIT_LIQUIDATION_ACTIONS.SAVE_FORM_IN_SERVICES,
	}
];

export const CreditLocationMultiFormContainer = () => {
	const history = useHistory();
	const [login] = useLogin();
	const [formData, setformData] = useState({});
	const {
		executeAction,
		step,
		enableButton,
		setEnableButton,
		showLoadingModal,
		showLongModal,
		setShowLoadingModal
	} = useCreditLiquidationFormContainerControl();

	const configAction: ActionButtonConfig[] = config.map((values) => {
		return {
			buttonBackName: values.buttonBackName,
			buttonNextName: values.buttonNextName,
			buttonBackClick: () => {
				executeAction(values.backAction, { ...formData, flow: 'CREDITLIQUIDATION', trafficSources: sessionStorage.getItem('trafficSources') });
			},
			buttonNextClick: () => {
				executeAction(values.nextAction, { ...formData, flow: 'CREDITLIQUIDATION', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		} as ActionButtonConfig;
	});

	useEffect(
		() => {
			setShowLoadingModal(true);
			login(
				() => setShowLoadingModal(false),
				() => history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`)
			);
		},
		//eslint-disable-next-line
		[]
	);

	const views: JSX.Element[] = [
		<CreditLiquidationPersonalInfoForm dataLayerKey={DATA_LAYER_RESPONSE_KEY.CREDIT_LIQUIDATION_INFO_PERSONAL} />,
		<CreditLiquidationEntityInfoForm
			dataLayerKey={DATA_LAYER_RESPONSE_KEY.CREDIT_LIQUIDATION_INFO_ENTITY}
		/>,
	];

	return (
		<>
			<FormContext.Provider
				value={{
					setError: setEnableButton,
					setData: setformData,
					//storage: storageService,
				}}
			>
				<LoadingModal showLoadingModal={showLoadingModal} isLongTime={showLongModal} />

				<MultiFormContainer
					controlConfig={configAction}
					views={views}
					currentStep={step}
					isError={enableButton}
				/>
			</FormContext.Provider>
		</>
	);
};
